import { PartnershipCardPointsUI } from "./PartnershipCardPointsUI";
import { StandardProps } from "../componentMap";
import { ensureIsActiveVariant } from "../../utils/product/ensureIsActive";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { isInStoreOnly } from "../../utils/variant/isInStoreOnly";

export const calculatePoints = (price: number, quantity = 1) => {
  const totalPrice = price * quantity;
  const points = Math.floor(totalPrice * 1.25);
  return points;
};

export function PartnershipCardPoints({
  product,
  experiences,
}: Pick<StandardProps, "product" | "experiences">) {
  const { variant } = useVariant(product);
  const { hidePartnershipCardPoints } = experiences;

  const activeVariant = ensureIsActiveVariant(variant);
  const isVariantInStoreOnly = !!activeVariant && isInStoreOnly(activeVariant);

  if (hidePartnershipCardPoints === "on") return null;
  if (!activeVariant) return null;
  if (isVariantInStoreOnly) return null;

  const currentPriceNumber = parseFloat(activeVariant.price.value);

  if (currentPriceNumber < 0.8) return null;

  const points = calculatePoints(currentPriceNumber);

  return <PartnershipCardPointsUI points={points} />;
}
